import { createBrowserRouter } from "react-router-dom";

import { 
  LoginPage, 
  NotFoundPage, 
  CashierLayoutPage,
  CashierProfilePage, 
  CashierTillPage,
  CashierDailyReports,


  AdminsysLayoutPage, 
  SupervisorLayoutPage,
  SupervisorAgenciesPage,
  SuperisorUsersPage,

  DistributorLayoutPage,
  DistributorDashboardPage,
  DistributorCashReceptionPage,
  DistributorProvisionningPage,
  CompanyPartnersPage,
  DistributorProfilePage,
  DistributorReportsPage,

  AdminsysDashboardPage,
  SupervisorDashboardPage,
  SupervisorMobileMoneyPage,
  AdminsysAreasPage,
  AdminsysAgenciesPage,
  AdminsysMobileMoneyPage,
  AdminsysUsersPage,
  AdminsysTillsPage,
  SupervisorTillsPage,
  SupervisorTillsAssignationPage,
  AdminsysCompaniesPage,
  AdminsysCompaniesProfilePage,
  AdminsysPartnersPage,
  CashierApproPage
} from "./pages";

export const AppRouter = createBrowserRouter([
  {
    path: "/",
    element: <LoginPage />,
    errorElement: <NotFoundPage />,
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/admin_sys',
    element: <AdminsysLayoutPage />,
    children: [
      {
        path: '',
        element: <AdminsysDashboardPage />
      },
      {
        path: 'companies',
        element: <AdminsysCompaniesPage />
      },
      {
        path: 'companies/:id',
        element: <AdminsysCompaniesProfilePage />
      },
      {
        path: 'areas',
        element: <AdminsysAreasPage/>,
      },
      {
        path: 'agencies',
        element: <AdminsysAgenciesPage/>,
      },
      {
        path: 'services',
        element: <AdminsysMobileMoneyPage/>,
      },
      {
        path: 'users',
        element: <AdminsysUsersPage/>,
      },
      {
        path: 'tills',
        element: <AdminsysTillsPage/>,
      },
      {
        path: 'partners',
        element: <AdminsysPartnersPage/>
      },
      {
        path: 'reception',
        element: <DistributorCashReceptionPage/>
      },
      {
        path: 'provisionning',
        element: <DistributorProvisionningPage/>
      }
    ]
  },
  {
    path: '/:companyName/cashier',
    element: <CashierLayoutPage/>,
    children: [
      {
        path: 'profile',
        element: <CashierProfilePage/>
      },
      {
        path: 'request-for-appros',
        element: <CashierApproPage/>
      },
      {
        path: 'my-till',
        element: <CashierTillPage/>
      },
      {
        path: 'daily-reports',
        element: <CashierDailyReports/>
      }
    ]
  },
  {
    path: '/:companyName/supervisor',
    element: <SupervisorLayoutPage />,
    children: [
      {
        path: '',
        element: <SupervisorDashboardPage/>
      },
      {
        path: 'agences',
        element: <SupervisorAgenciesPage/>,
      },
      {
        path: 'users',
        element: <SuperisorUsersPage/>,
      },
      {
        path: 'tills',
        element: <SupervisorTillsPage/>,
      },
      {
        path: 'tills/:tillId/assignations',
        element: <SupervisorTillsAssignationPage/>
      },
      {
        path: 'partners',
        element: <CompanyPartnersPage/>
      },
      {
        path: 'reception',
        element: <DistributorCashReceptionPage/>
      },
      {
        path: 'services',
        element: <SupervisorMobileMoneyPage/>
      }
    ]
  },
  {
    path: '/:companyName/distributor',
    element: <DistributorLayoutPage />,
    children: [
      {
        path: '',
        element: <DistributorDashboardPage/>
      },
      {
        path: 'reception',
        element: <DistributorCashReceptionPage/>
      },
      {
        path: 'provisionning',
        element: <DistributorProvisionningPage/>
      },
      {
        path: 'tills',
        element: <SupervisorTillsPage/>
      },
      {
        path: 'partners',
        element: <CompanyPartnersPage/>
      },
      {
        path: 'profile',
        element: <DistributorProfilePage/>
      },
      {
        path: 'reports',
        element: <DistributorReportsPage/>
      }
    ]
  },
  
]);